import React from "react";
import "./index.css";

export default function SocialLinks({width = 500, height = 300}) {
  return (
    <div className="social-container" style={{height: `${height}px`, width: `${width}px`}}>
    <nav className="social-card" aria-label="Enlaces a redes y contacto">

      <div className="social-list">

        {/* Instagram */}
        <div className="social-field">
          <a
            className="social-link instagram"
            href="https://www.instagram.com/gonzaloautor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm5 6.2A3.2 3.2 0 1 0 15.2 11 3.2 3.2 0 0 0 12 8.2zm6.4-.9a1.2 1.2 0 1 0 1.2 1.2 1.2 1.2 0 0 0-1.2-1.2z"/>
            </svg>
          </a>
          <label className="social-title">Instagram</label>
        </div>

        {/* Facebook */}
        <div className="social-field">
          <a
            className="social-link facebook"
            href="https://www.facebook.com/gonzaloautor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M22 12.07C22 6.49 17.52 2 12 2S2 6.49 2 12.07c0 4.99 3.66 9.13 8.44 9.93v-7.04H8.08v-2.9h2.36V9.41c0-2.33 1.38-3.61 3.5-3.61.99 0 2.03.18 2.03.18v2.23h-1.14c-1.12 0-1.47.7-1.47 1.42v1.7h2.5l-.4 2.9h-2.1v7.04C18.34 21.2 22 17.06 22 12.07z"/>
            </svg>
          </a>
          <label className="social-title">Facebook</label>
        </div>

        {/* TikTok */}
        <div className="social-field">
          <a
            className="social-link tiktok"
            href="https://www.tiktok.com/@gonzalo.autor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="TikTok"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 3v10.5A4.5 4.5 0 1 1 11.5 9V7a6 6 0 0 0 4.5-4zM9 21.5A3.5 3.5 0 1 0 12.5 18H9v3.5z"/>
            </svg>
          </a>
          <label className="social-title">TikTok</label>
        </div>

        {/* Youtube */}
        <div className="social-field">
          <a
            className="social-link youtube"
            href="https://www.youtube.com/@gonzaloautor"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.6,3.2H4.4C3,3.2,1.8,4.4,1.8,5.8v12.3c0,1.4,1.2,2.6,2.6,2.6h15.2c1.4,0,2.6-1.2,2.6-2.6V5.8C22.2,4.4,21,3.2,19.6,3.2z
                M10,16.3V7.7l6.2,4.3L10,16.3z"/>
            </svg>
          </a>
          <label className="social-title">YouTube</label>
        </div>

        {/* Email */}
        <div className="social-field">
          <a
            className="social-link email"
            href="mailto:contacto@corazondeguerrero.com.ar"
            aria-label="Enviar email"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zM4 8l8 5 8-5v-2l-8 5L4 6z"/>
            </svg>
          </a>
          <label className="social-title">e-mail</label>
        </div>

      </div>
      
    </nav>
    </div>
  );
}
